<div class="mech-diag-content">
	@if (component) {
	<div>
		@for (ci of ciCriticals; track ci) {
		<app-dvs-chart [error]="ci.errormessage" [options]="ci.options" [timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
		}
		@if (!showOptional) {
		<div class="optional-expander">
			<button (click)="enableOptionals()" class="button wide">Show optional CIs <i class="icon-down-open"></i></button>
		</div>
		}
		<div [hidden]="!showOptional">
			@for (ci of ciOptionals; track ci) {
			<app-dvs-chart [error]="ci.errormessage" [options]="ci.options" [timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
			}
		</div>
	</div>
	}
	<div class="trend-options">
		<div class="row justify-content-sm-center">
			<div class="col-sm-auto">
				<div class="form-check">
					<label>
						<input [(ngModel)]="useXAxisDate" (ngModelChange)="RefreshChart()" type="checkbox">
						X-Axis by date
					</label>
				</div>
			</div>
			@if (!asset.is_fixed) {
			<div class="col-sm-auto">
				<div class="form-check">
					<label>
						<input [(ngModel)]="compareRegimes" (ngModelChange)="RefreshChart()" type="checkbox">
						Compare to regime
					</label>
				</div>
			</div>
			}
			@if (dataExceedsLimit) {
			<div class="col-sm-auto">
				<div class="form-check">
					<label title="Chart is normally limited to the last 15k points. Viewing all data may cause your browser to crash.">
						<input [(ngModel)]="unlimitedChart" (ngModelChange)="RefreshChart()" type="checkbox">
						Show all data
					</label>
				</div>
			</div>
			}
		</div>
	</div>
</div>